// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__YiDue","content":"LoadingAlert_content__1RaLD"};